import { FleetManagementRow, VehicleBookingEventDto } from "../../types/FleetManagement-row.types";
import { VehicleBlockingEvent } from "../../types/FleetManagement.types";
import { FleetCalendarEvent } from "../FleetManagementEventDetailDialog.component";
import {
  mapBlockingEventsToFleetCalendarEvents,
  mapBookingEventsToFleetCalendarEvents,
  mapFleetEventSchedules
} from "./mapFleetEventSchedules.function";

export function buildEventsForAllFleet(
  stableAllFleetData: FleetManagementRow[],
  bookingEventsForAllFleet: VehicleBookingEventDto[] | undefined,
  effectiveBlockingEvents: VehicleBlockingEvent[],
  timezone: string
): FleetCalendarEvent[] {
  const events: FleetCalendarEvent[] = [];

  // When bookingEvents are provided from the calendar API, group them by vehicle
  // and prefer them over row.occupiedBooking for the calendar view.
  const bookingsByVehicle = new Map<number, VehicleBookingEventDto[]>();
  if (bookingEventsForAllFleet?.length) {
    bookingEventsForAllFleet.forEach(be => {
      const id = be.vehicleInventoryId;
      if (id == null) return;
      const list = bookingsByVehicle.get(id) ?? [];
      list.push(be);
      bookingsByVehicle.set(id, list);
    });
  }

  stableAllFleetData.forEach(row => {
    const apiBookings = bookingsByVehicle.get(row.id);
    if (apiBookings && apiBookings.length > 0) {
      events.push(...mapBookingEventsToFleetCalendarEvents(apiBookings, row.id, timezone));
    } else {
      const rowEvents = mapFleetEventSchedules({ selectedRow: row, timezone });
      events.push(...rowEvents.filter(e => String(e.id).startsWith("booking-")));
    }
  });

  if (effectiveBlockingEvents.length > 0) {
    events.push(...mapBlockingEventsToFleetCalendarEvents(effectiveBlockingEvents, timezone));
  } else {
    // When no blocking events from API, fall back to the row-based blocked events
    stableAllFleetData.forEach(row => {
      const rowEvents = mapFleetEventSchedules({ selectedRow: row, timezone });
      events.push(...rowEvents.filter(e => String(e.id).startsWith("block-")));
    });
  }

  return events;
}

export function buildEventsForSingleVehicle(
  selectedRow: FleetManagementRow,
  bookingEventsForVehicle: VehicleBookingEventDto[] | undefined,
  effectiveBlockingEvents: VehicleBlockingEvent[] | undefined,
  timezone: string
): FleetCalendarEvent[] {
  const events: FleetCalendarEvent[] = [];

  if (bookingEventsForVehicle != null && bookingEventsForVehicle.length > 0) {
    events.push(
      ...mapBookingEventsToFleetCalendarEvents(bookingEventsForVehicle, selectedRow.id, timezone)
    );
  } else {
    const rowEvents = mapFleetEventSchedules({ selectedRow, timezone });
    events.push(...rowEvents.filter(e => String(e.id).startsWith("booking-")));
  }

  if (effectiveBlockingEvents != null && effectiveBlockingEvents.length > 0) {
    events.push(...mapBlockingEventsToFleetCalendarEvents(effectiveBlockingEvents, timezone));
  } else {
    const rowEvents = mapFleetEventSchedules({ selectedRow, timezone });
    events.push(...rowEvents.filter(e => String(e.id).startsWith("block-")));
  }

  return events;
}
